import React, { Component } from 'react';
import { withRouter } from "react-router-dom";


class InsideContact extends Component {

    render() {
        return (
            <div className="col-lg-3 col-md-6 col-sm-12 well">
                <p>
                    <h4>We Are Here For You!</h4>
                    Please let us know what we can do for you and we will get back to you just as soon as possible.<br /><br />

                </p>
                <p>
                    <form>
                        <div className="form-group">
                            <input type="text" className="form-control" id="" placeholder="Your Name" />
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" id="" placeholder="Company Name" />
                        </div>
                        <div className="input-group form-group">

                            <span className="input-group-addon glyphicon glyphicon-envelope" id=""></span> <input type="email" className="form-control" id="" placeholder="Your Email" />
                        </div>

                        <div className="input-group form-group">

                            <span className="input-group-addon glyphicon glyphicon-phone-alt" id=""></span> <input type="number" min="10" max="14" className="form-control" id="" placeholder="Telephone" />
                        </div>
                        <div className="form-group message">
                            <textarea className="form-control" rows="6" id="message" name="message" placeholder="Type your comments or questions here..."></textarea>
                        </div>


                        <button type="submit" className="btn btn-warning colorBlack">Submit</button>
                    </form>
                </p>
            </div>
        );
    }
}

export default withRouter(InsideContact);


// WEBPACK FOOTER //
// ./src/components/InsideContact.js